import {XauditModel} from '../xaudit.model';
import {CaseProcedureFormConfigurationModel} from './case-procedure-form-configuration.model';
import {CaseProcedureAdaCodeConfigurationModel} from './case-procedure-ada-code-configuration.model';

export class CaseProcedureConfigurationModel extends XauditModel {
  CaseProcedureId: string;
  Code: string;
  Description: string;
  HasChildren: boolean;
  ParentCaseProcedureId: string;
  PresentOrder: number;
  ProcedureName: string;
  ResultingConditionID: string;
  TDOCID: number;
  cfgCaseProcedureForms: CaseProcedureFormConfigurationModel[] = [];
  cfgCaseProcedureADACodes: CaseProcedureAdaCodeConfigurationModel[] = [];
  // TODO: add models
  cfgCaseWorkAreaProcedures;
  cfgProcedureGroupItems;
  dataPatientCaseWorkItems;
  enumMedicalSpecialtyID: string;
  enumProcedureCategoryID: string;
  enumProcedureActionCategoryID: string;
  enumProcedureTypeID: string;
  isSelected: boolean;
  isDoNotDeploy: boolean;
}
